document.querySelectorAll('.thumbnail-list__item').forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const activeListItem = document.querySelector('.is-active');
            if (activeListItem) {
              const video = activeListItem.querySelector('video');
              if (video) {
                video.controls = false;
                video.loop = 'loop';
                if(video.paused){
                  video.play();
                }                
              }
            }
      });
  });

document.querySelectorAll('.thumbnail-list__item .thumbnail__badge').forEach(function(thumbIcon) {
    thumbIcon.addEventListener('click', function() {
        var listItem = this.closest('.thumbnail-list__item');
        var button = listItem.querySelector('button');
        if(button){
          button.click();
        }
    });
});
// document.querySelectorAll('.deferred-media').forEach(function(thumbImage) {
//       thumbImage.addEventListener('click', function() {        
//         const activeButton = document.querySelector('button[aria-current="true"]'); 
//             if(activeButton){              
//               activeButton.click();
//             }
//       });
// });

document.querySelectorAll('.deferred-media').forEach(function(thumbImage) {
      thumbImage.addEventListener('click', function() {    
        const parentMediaItem = this.closest('.product__media-item');
        const media_id = parentMediaItem.getAttribute('data-media-id');
        const activeButton = document.querySelector('.thumbnail-list__item[data-target="'+media_id+'"] button')
        if(activeButton){              
            activeButton.setAttribute('aria-current', true);
        }

        // const activeButton = document.querySelector('button[aria-current="true"]'); 
        //     if(activeButton){              
        //       activeButton.click();
        //     }
      });
});
document.querySelectorAll('.product__modal-opener .product__media-icon, .product__media').forEach(function(icon) {
      icon.addEventListener('click', function() {
        const parentMediaItem = this.closest('.product__media-item');
        var activeMediaimg = parentMediaItem.querySelector('.product__media');
        var deferredMedia = parentMediaItem.querySelector('.deferred-media');
        var productMediaIcon = parentMediaItem.querySelector('.product__media-icon');        
        const videoElement = parentMediaItem.querySelector('video');
        var listItem = parentMediaItem.closest('.product__media-list');

        const media_id = parentMediaItem.getAttribute('data-media-id');

        listItem.querySelectorAll('.product__media-item').forEach(function(mediaItem) {
          mediaItem.classList.remove('is-active');  
        });
        parentMediaItem.classList.add('is-active');        
        if (videoElement) { 
          deferredMedia.style.display = 'block';
          activeMediaimg.style.display = 'none'; 
          videoElement.play();   
          
          const activeButton = document.querySelector('.thumbnail-list__item[data-target="'+media_id+'"] button')
          if(activeButton){              
              activeButton.setAttribute('aria-current', true);
            }
        }else{
            // const activeButton = document.querySelector('button[aria-current="true"]'); 
            const activeButton = document.querySelector('.thumbnail-list__item[data-target="'+media_id+'"] button')
            if(activeButton){              
              activeButton.click();
            }
        }        
      });
});



window.addEventListener('load', function() {

    const checkedColor = document.querySelector(
        'input[type="radio"]:checked'
    );

    if (checkedColor) {
        checkedColor.dispatchEvent(
            new Event('change', { bubbles: true })
        );
    }

});

/*function updateVariantImages() {

    const variantInput =
        document.querySelector('.product-variant-id');

    if (!variantInput) return;

    const variantId = variantInput.value;

    const currentPosition =
        Number(window.variantImageGroups[variantId]);

    if (!currentPosition) return;

    const positions = Object.values(window.variantImageGroups)
        .map(Number)
        .sort((a, b) => a - b);

    let nextPosition = 99999;

    positions.forEach(pos => {
        if (pos > currentPosition && pos < nextPosition) {
            nextPosition = pos;
        }
    });

    document.querySelectorAll('.thumbnail-list__item')
        .forEach(item => {

            const position =
                Number(item.dataset.mediaPosition);

            const show =
                position >= currentPosition &&
                position < nextPosition;

            item.hidden = !show;
        });

    const firstVisibleThumb = document.querySelector('.thumbnail-list__item:not([hidden]) button');

    if (firstVisibleThumb) {

        setTimeout(() => {

            firstVisibleThumb.dispatchEvent(
                new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true
                })
            );

        }, 100);
    }
}*/

function updateVariantImages() {

    const checkedColor = document.querySelector(
        'input[name="Color"]:checked'
    );

    if (!checkedColor) return;

    const selectedColor = checkedColor.value.trim();

    let firstVisibleThumb = null;

    document.querySelectorAll('.thumbnail-list__item').forEach(item => {

        const imageColor = (item.dataset.color || '')
            .replace('#', '')
            .trim();

        const show =
            imageColor.toLowerCase() === selectedColor.toLowerCase();

        item.hidden = !show;

        if (show && !firstVisibleThumb) {
            firstVisibleThumb = item.querySelector('button');
        }
    });

    document.querySelectorAll('.product__media-item').forEach(item => {

        const imageColor = (item.dataset.color || '')
            .replace('#', '')
            .trim();

        const show =
            imageColor.toLowerCase() === selectedColor.toLowerCase();

        item.classList.toggle('hide_img', !show);
    });

    if (firstVisibleThumb) {
        setTimeout(() => {
            firstVisibleThumb.click();
        }, 100);
    }
}

document.addEventListener('change', function(e) {

    if (!e.target.matches('input[name="Color"]')) return;

    setTimeout(updateVariantImages, 300);
});

document.addEventListener('DOMContentLoaded', function() {

    const waitForVariant = setInterval(() => {

        const variantInput = document.querySelector('.product-variant-id');

        if (!variantInput || !variantInput.value) return;

        clearInterval(waitForVariant);

        updateVariantImages();

    }, 100);

});

// visibility change
function handleReturnToPage() {
  const activeMediaItem = document.querySelector('.product__media-item.is-active');
  if (!activeMediaItem) return;

  const videoElement = activeMediaItem.querySelector('video');
  if (!videoElement) return;

  if (videoElement.paused) {
    videoElement.muted = true;
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('webkit-playsinline', '');

// alert('play');
    videoElement.play().catch(function() {
      // Safari blocked autoplay — show tap overlay
      activeMediaItem.classList.remove('is-active');
    //   showPlayOverlay(activeMediaItem, videoElement);
    });
  }
}

// Chrome / Android
document.addEventListener('visibilitychange', function() {
  if (document.visibilityState === 'visible') {
    // alert('visible');
    handleReturnToPage();
  }
});

// // Safari iOS
// window.addEventListener('pageshow', function() {
//     alert('pageshow');
//   handleReturnToPage();
// });

// Safari focus fallback
// window.addEventListener('focus', function() {
//     // alert('focus');
//   handleReturnToPage();
// });